import MarkerLayer from 'layers/types/_base/MarkerLayer';
import SecondaryHotelsProvider from "./providers/SecondaryHotelsProvider";
import BaseLayer from 'layers/types/_base/BaseLayer';
import Utils from 'helpers/Utils';

const METTERS_RADIO_BOUNDING_TARGET = 100;
let SecondaryHotelsLayer = MarkerLayer.extend({
    constructor(options) {
        this.markers = [];
        BaseLayer.prototype.constructor.call(this, options);
    },

    initialize(options) {
        this.options.provider = new SecondaryHotelsProvider(options);
        this.options.preFilters = [];
        this.options.postFilters = [];
        this.options.markersClickable = true;
        this.options.minZoom = options.minZoom !== undefined ? options.minZoom : 16;
        if (this.isAvailableZoom(this.options.minZoom)) {
            this.options.model.show();
        }
        this.options.model.activate();
        MarkerLayer.prototype.initialize.call(this, options);
        this.options.provider.load();
        this.listenTo(this.widget.bus, 'HOTEL_CHANGED', data => {
            const marker = this.getMarkerFromId(data.hotelId);
            const newBounds = Utils.getBoundsFromPoint(marker.position, METTERS_RADIO_BOUNDING_TARGET);
            this.widget.map.fitBounds(newBounds);
        });
        this.listenTo(this.widget.bus, 'CLICK_ON_MARKER', marker => {
            if (this.widget.api.onClickInAlternativeHotel) {
                this.widget.api.onClickInAlternativeHotel(marker.id);
            }
		});
    },

    add() {

    },

    remove() {

    }
});

export default SecondaryHotelsLayer;


// WEBPACK FOOTER //
// ./src/layers/SecondaryHotelsLayer.js